// List of error codes from OKX: https://www.okx.com/docs-v5/en/#error-code-rest-api-public
import {
  DerivativesMarginMode,
  DerivativesOrderCondition,
  DerivativesOrderSide,
  DerivativesOrderType,
  DerivativesPositionMode,
} from 'common/api/autogenerated/trading-gateway';

import { ActiveFields, DerivativeOrderFormType, DerivativesPriceType } from './types';

// TGW adds prefix "FSO" to each error code
export const FUTURES_ERRORS = {
  FU005: 'futures:configuration:empty', // "Customer login was not created" - happens when update future pair configuration while future account wasn't created
  FSO52915: 'futures:create:insufficient_liquidity',
  FSO51008: 'futures:create:insufficient-balance',
  FSO51005: 'futures:create:max',
  FSO51202: 'futures:create:max',
};

export const defaultValues: DerivativeOrderFormType = {
  mode: 'create',
  marginMode: DerivativesMarginMode.CROSS,
  positionMode: DerivativesPositionMode.HEDGE,
  condition: DerivativesOrderCondition.GOOD_TILL_CANCELLED,
  triggerPriceType: DerivativesPriceType.LAST,
  limitPriceType: DerivativesPriceType.LAST,
  takeProfitTriggerPriceType: DerivativesPriceType.LAST,
  stopLossTriggerPriceType: DerivativesPriceType.LAST,
  leverage: 10,
  action: DerivativesOrderSide.BUY,
  balance: 0,
  base: '',
  quoted: '',
  tpsl: false,
  reduceOnly: false,
  quantity: undefined,
  total: undefined,
  takeProfit: undefined,
  stopLoss: undefined,
  triggerPrice: undefined,
  targetPrice: undefined,
  bestAsk: undefined,
  bestBid: undefined,
  limitPrice: undefined,
  activeField: ActiveFields.QUONTITY,
  type: DerivativesOrderType.MARKET,
  useBestPrice: false,
  allowSaveConfiguration: false,
  percentage: null,
  liquidity: true,
  tradingPairCode: '',
  takerFeeRate: 0,
  isDirtyFromProps: false,
};
